export default class VehicleDetail {
    constructor(el, target, desktopTarget) {
        this.DOM = { el: el, target: target, desktopTarget: desktopTarget };
        this.breakpoint = 1280;
        this.isMobileView = false;
        this.initEvents();
    }

    initEvents() {
        if (window.innerWidth < this.breakpoint) {
            replaceNode(this.DOM.el, this.DOM.target);
            this.isMobileView = true;
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth < this.breakpoint && !this.isMobileView) {
                replaceNode(this.DOM.el, this.DOM.target);
                this.isMobileView = true;
            }
            if (window.innerWidth >= this.breakpoint && this.isMobileView) {
                replaceNode(this.DOM.el, this.DOM.desktopTarget, true);
                this.isMobileView = false;
            }
        });

        function replaceNode(node, target, append = false) {
            if (node) {
                node.remove();
            }

            if (target && node) {
                if (append) {
                    target.append(node);
                } else {
                    target.after(node);
                }
            }
        }
    }
}

const vehicleDetailNode = document.getElementById('vehicle-intro')
const vehicleDetailTargetNode = document.getElementById('carousel-vehicle-wrapper')
const vehicleDetailDesktopTargetNode = document.getElementById('vehicle-intro-parent')
if (vehicleDetailNode !== null && vehicleDetailTargetNode !== null && vehicleDetailDesktopTargetNode !== null) {
    new VehicleDetail(vehicleDetailNode, vehicleDetailTargetNode, vehicleDetailDesktopTargetNode)
}
